/**
 * Switching a variant swatch on a product page normally updates price/buttons via a client-side
 * fetch, without a full page load. That's requested to instead trigger a real page reload for the
 * new variant, so the page is always a fresh, fully server-rendered view for whichever variant is
 * selected.
 *
 * ThemeEvents.variantUpdate fires (see assets/events.js) after that client-side fetch completes,
 * carrying the new variant's id — used here only to build the reload URL, not to sync any DOM
 * state by hand.
 *
 * variant-picker.js already silently rewrites the current URL's ?variant= via
 * history.replaceState right after the swatch click (before this event fires), so the URL here
 * usually already matches the target variant — do NOT skip navigating just because the URL
 * string already matches; window.location.href always forces a real reload regardless.
 */
import { ThemeEvents } from '@theme/events';

document.addEventListener(ThemeEvents.variantUpdate, function (event) {
  try {
    var variantId = event.detail && event.detail.resource && event.detail.resource.id;
    if (!variantId) return;

    var sourceEl = event.target;
    var isProductCardOrQuickAdd =
      sourceEl &&
      typeof sourceEl.closest === 'function' &&
      (sourceEl.closest('product-card') || sourceEl.closest('quick-add-dialog'));
    if (isProductCardOrQuickAdd) return;

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    var newHref = url.toString();

    if (newHref === window.location.href) {
      window.location.reload();
    } else {
      window.location.href = newHref;
    }
  } catch (e) {}
});
